var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3094_79)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5004 24.0379C18.8729 24.0379 24.0388 18.8719 24.0388 12.4994C24.0388 6.12688 18.8729 0.960938 12.5004 0.960938C6.12786 0.960938 0.961914 6.12688 0.961914 12.4994C0.961914 18.8719 6.12786 24.0379 12.5004 24.0379Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5383 7.35547C13.527 8.12356 13.3465 8.87971 13.0094 9.56999C12.6724 10.2603 12.1872 10.8677 11.5884 11.3489C10.9897 11.8301 10.2921 12.1733 9.54546 12.3539C8.79883 12.5346 8.02154 12.5482 7.26902 12.3939C7.26449 12.429 7.26449 12.4646 7.26902 12.4997C7.26863 13.4937 7.55042 14.4673 8.08161 15.3074C8.6128 16.1476 9.37161 16.8196 10.2697 17.2455C11.1678 17.6713 12.1683 17.8335 13.155 17.7131C14.1416 17.5927 15.0738 17.1946 15.8432 16.5653C16.6125 15.9359 17.1874 15.1011 17.501 14.1579C17.8145 13.2147 17.8538 12.2019 17.6144 11.2372C17.375 10.2725 16.8666 9.39555 16.1485 8.7084C15.4303 8.02124 14.5318 7.55208 13.5575 7.35547H13.5383Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3094_79"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgView);
export default __webpack_public_path__ + "static/media/view.5a4dce6756fb48e6146f6b7f48f0a50b.svg";
export { ForwardRef as ReactComponent };